import { createUseStyles } from 'react-jss'
import {
  addProps,
  addDisplayName,
  addHandlers,
  flowMax,
  addState,
  addStateHandlers,
} from 'ad-hok'
import { FC } from 'react'
import { addApi } from 'shared/src/api'
import saveAs from 'file-saver'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { Button } from './Button'

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    marginTop: 20,
  },
  input: {
    marginRight: 10,
  },
})

export const ProductsExtraHeader: FC = flowMax(
  addDisplayName('ProductsExtraHeader'),
  addStateHandlers(
    {
      url: '',
    },
    {
      onChange: () => (event: React.ChangeEvent<HTMLInputElement>) => ({
        url: event.target.value,
      }),
    }
  ),
  addState('isExporting', 'setExporting', false),
  addApi,
  addTranslationHelpers,
  addHandlers({
    onExport:
      ({ url, api, setExporting }) =>
      async () => {
        if (!url) {
          return
        }

        setExporting(true)

        try {
          const response = await api.products.exportShopify(url)
          const blob = await response.blob()
          saveAs(blob, 'shopify-products.csv')
        } catch (error) {
          alert('Error exporting Shopify products')
        } finally {
          setExporting(false)
        }
      },
  }),
  addProps(() => ({
    classes: useStyles(),
  })),
  ({ url, onChange, onExport, isExporting, classes, t }) => (
    <div className={classes.container}>
      <input
        type="url"
        value={url}
        onChange={onChange}
        placeholder={t('admin.resources.products.shopifyUrlPlaceholder')}
        className={classes.input}
      />
      <Button
        text={t('admin.resources.products.exportShopify')}
        onClick={onExport}
        disabled={isExporting || !url}
      />
    </div>
  )
)
